import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router";
import { paths } from "./paths";
import Button from "../../_components/ui/Button";
import "./_route-error-boundary.scss";

// Root-level errorElement: catches render-time throws and lazy-chunk load
// failures anywhere in the route tree. Distinct from the explicit `path: "*"`
// 404 route, which handles unmatched URLs, not crashes.
const RouteErrorBoundary = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  const message = isRouteErrorResponse(error)
    ? error.statusText || "This page could not be found."
    : error?.message || "Something went wrong. Please try again.";

  return (
    <div className="route-error-boundary">
      <h1 className="route-error-boundary__title">Something went wrong</h1>
      <p className="route-error-boundary__message">{message}</p>
      <Button
        className="route-error-boundary__action"
        onClick={() => navigate(paths.home, { replace: true })}
        variant="contained"
        size="md"
      >
        Go to Home
      </Button>
    </div>
  );
};

export default RouteErrorBoundary;
